import api from 'api';
import {useGetApi} from 'common/hooks/useGetApi';
import {useIsPermittedByRole} from 'common/hooks/useIsPermittedByRole';
import {useEffect, useMemo} from 'react';
import {ILdapSettings} from 'types/diplomat/LdapSettings';
import {AdminResourceType} from 'types/diplomat/settings/adminroles/AdminResourceType';
import {enums} from 'types/enums';

export const useIsLdapConfigured = () => {
   const isPermittedbyRole = useIsPermittedByRole();

   const {request: fetchLdapSettings, state: session, loading} = useGetApi<ILdapSettings>(
      api.ldapSettings
   );

   useEffect(() => {
      isPermittedbyRole(AdminResourceType.enum.SETTINGS) && fetchLdapSettings();
   }, [fetchLdapSettings, isPermittedbyRole]);

   const isLdapConfigured = useMemo(() => {
      return (
         session &&
         session.address &&
         (session.bindingType === enums.bindingType.enum.ANONYMOUS ||
            session.bindingType === enums.bindingType.enum.AUTHENTICATED) &&
         session.userDN &&
         session.password
      );
   }, [session]);

   return isLdapConfigured;
};
